// Modules
import React, { ReactChild } from 'react'
import { Button } from '@dasa-health/components-react'

// Component
import { ContainerGlobal, Container, Content, Illustration } from './styles'

interface Props {
    children: ReactChild
    image: string
    goTo: () => void
    title: string
    buttonText: string
    imageAlt: string
    isLoading?: boolean
}

export const TemplateContainerFullWidthBlue: React.FC<Props> = props => {
    const { children, image, goTo, title, buttonText, imageAlt, isLoading } = props
    return (
        <ContainerGlobal>
            <Container>
                <Content>
                    {<Illustration alt={imageAlt} data-testid="content-illustration" src={image} />}
                    <h1 className="title">{title}</h1>
                    {children}
                    <Button
                        data-current-service="Reconhecimento Facial"
                        data-item-position="Confirmação identidade sem contato no MDM"
                        data-item-text={buttonText}
                        data-testid="content-button"
                        fullWidth={true}
                        isLoading={isLoading}
                        onClick={goTo}
                        size="default"
                        sx={{
                            backgroundColor: '#FEFEFE',
                        }}
                        type="button"
                        variant="secondary"
                    >
                        {buttonText}
                    </Button>
                </Content>
            </Container>
        </ContainerGlobal>
    )
}
